<template>
    <div>

<section class="content">
<div class="container-fluid">

        <div class="row clearfix">

            <div class="bg-light-green" style="margin-top:-1% !important;">
                <!-- <br> -->
                <div class="row paddingku">
                    <div class="col-md-6 searching">
                        <span class="h_page">Sasaran</span> <br> <br>
                    </div>
                    <div class="col-md-3">

                    </div>
                    <div class="col-md-3 searching">
                        <div class="input-group">
                            <span class="input-group-btn">
                                <button @click="cek_tujuan_add" type="button" class="btn bg-light-blue btn-sm waves-effect" title="Tambah Data" data-toggle="modal" data-target="#m_tambah_data">
                                    <i class="material-icons">add</i>
                                </button>
                            </span>
                            <input type="text" class="form-control" placeholder="Cari data" id="caridata" >
                        </div> <br>
                    </div>
                </div>
            </div>


            <div class="col-xs-12 card">
                <br>
                <div class="row">
                    <div class="col-md-4">
                        <span class="huruf_input">Periode RPJMD</span>
                        <select @change="getMisi()" v-model="filter_rpjmd" class="form-control">
                            <option value="" >-- Semua Periode --</option>
                            <option v-for="data in list_rpjmd" :key="data.rpjmd_id" v-bind:value="data.rpjmd_id">	{{data.periode}}</option>
                        </select>
                    </div>


                    <div class="col-md-4">
                        <span class="huruf_input">Pilih Misi</span>
                        <select @change="getTujuan()" v-model="filter_misi" class="form-control" :disabled="filter_rpjmd==''">
                            <option value="" >-- Semua Misi --</option>
                              <option v-for="(data) in list_misi" :key="data.misi_id" v-bind:value="data.misi_id">	&#91;	{{data.no_misi}}&#93;	{{data.uraian}}</option>
                        </select>
                    </div>

                    <div class="col-md-4">
                        <span class="huruf_input">Pilih Tujuan</span>
                        <select @change="getData()" v-model="filter_tujuan" class="form-control" :disabled="filter_misi=='' || filter_rpjmd==''">
                            <option value="" >-- Semua Tujuan --</option>
                              <option v-for="(data) in list_tujuan" :key="data.tujuan_id" v-bind:value="data.tujuan_id">	&#91;{{data.no_misi}}.{{data.no_tujuan}}&#93;	{{data.uraian}}</option>
                        </select>
                    </div>
                </div>

        <!-- ============================================================ MULAI ======================================================================== -->
                <br>
                <div class="table-responsive">
                    <table class="table table-bordered" style="width: 100%">
                        <thead>
                        <tr class="bg-success kepala_table_f tabel_center">
                            <!-- <th class="tabel_center text-center" style="width: 5%">No.</th> -->
                            <th class="tabel_center text-center" style="width: 8%">Kode</th>
                            <th class="tabel_center text-center" style="width: 40%">Uraian Sasaran</th>
                            <th class="tabel_center text-center" style="width: ">Keterangan</th>
                            <th class="tabel_center text-center" style="width: 15%">#</th>
                        </tr>
                        </thead>
                        <tbody>
                            <tr v-if="cek_load_data">
                                <td colspan="4" class="text-center">
                                    <img src="images/loading-plan.gif" width="450px">
                                </td>
                            </tr>
                            <template v-if="!cek_load_data">
                                <tr class="h_isitable" v-for="data in list_sasaran" :key="data.sasaran_id">
                                    <!-- <td class="tabel_center text-center">1.</td> -->
                                    <td class="tabel_center text-center">{{data.no_misi}}.{{data.no_tujuan}}.{{data.no_sasaran}}</td>
                                    <td class="tabel_center" >{{data.uraian}}</td>
                                    <td class="tabel_center text-justify">{{data.keterangan}}</td>

                                    <td class="tabel_center text-center" >
                                        <button @click="selectDataIndikatorSasaranData(data)" class="btn bg-light-blue btn-xs waves-effect" title="Indikator Sasaran Pembangunan" id="edit_data" data-toggle="modal" data-target="#m_indikator_sasaran_pembangunan">
                                            <i class="material-icons" >control_point</i>
                                        </button>
                                            &nbsp;
                                        <button @click="selectData(data)" class="btn bg-light-green btn-xs waves-effect" title="Edit Data" id="edit_data" data-toggle="modal" data-target="#m_edit_data">
                                            <i class="material-icons" >create</i>
                                        </button>
                                            &nbsp;
                                        <button @click="removeData(data.sasaran_id)" class="btn bg-red btn-xs waves-effect" title="Hapus Data" id="hapus_data">
                                            <i class="material-icons" >clear</i>
                                        </button>
                                    </td>
                                </tr>
                            </template>

                        </tbody>
                    </table>
                </div>

                <hr>
                    <div class="text-center">
                        <button @click="btn_prev" type="button" class="btn btn-xs bg-blue waves-effect" id="pref">
                            <i class="material-icons">skip_previous</i>
                        </button>
                        &nbsp;
                        <span style="font-size: 85%; color: #a5a5a5">
                            <b>{{page_first}} - {{page_last}}</b>
                        </span>
                        &nbsp;
                        <button @click="btn_next" type="button" class="btn btn-xs bg-blue waves-effect" id="next">
                            <i class="material-icons">skip_next</i>
                        </button>
                    </div>
                <hr>
                <!-- ============================================================ MODAL ======================================================================== -->


                  <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                    <div class="modal fade" id="m_tambah_data" tabindex="-1" role="dialog" data-backdrop="static">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header bg-light-blue">
                                    <button @click="emptyData()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span></button>
                                    <h4 class="modal-title" id="largeModalLabel">TAMBAH DATA</h4>
                                </div>

                                    

                                    <form @submit.prevent="addData()">
                                        <div class="modal-body">

                                            

                                            <div v-if="!cek_tujuan" class="text-center">
                                                <span> 
                                                    <i class="material-icons col-orange">warning</i> <br>
                                                    <b>MOHON PILIH TUJUAN TERLEBIH DAHULU...!!!</b>
                                                </span>
                                            </div>

                                            <div v-if="cek_tujuan">
    
                                                <div class="row clearfix">
                                                    <div class="col-md-2 form-control-label">
                                                        <label for="kode">No Sasaran</label>
                                                    </div>
                                                    <div class="col-md-10">
                                                        <div class="form-group">
                                                            <div class="form-line">
                                                                <input v-model="no_sasaran" type="number" min="1" class="form-control" placeholder="Nomor Sasaran">
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="row clearfix">
                                                    <div class="col-md-2 form-control-label">
                                                        <label for="kode">Uraian Sasaran</label>
                                                    </div>
                                                    <div class="col-md-10">
                                                        <div class="form-group">
                                                            <div class="form-line">
                                                                <input v-model="uraian" type="text" class="form-control" placeholder="Ex : Meningkatnya Pelayanan Publik">
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                

                                                <div class="row clearfix">
                                                    <div class="col-md-2 form-control-label">
                                                        <label for="kode">Keterangan</label>
                                                    </div>
                                                    <div class="col-md-10">
                                                        <div class="form-group">
                                                            <div class="form-line">
                                                                <textarea v-model="keterangan" rows="4" class="form-control no-resize" placeholder="Masukan Keterangan..."></textarea>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="modal-footer">

                                            <button v-if="cek_tujuan" type="submit" class="btn btn-info waves-effect">SIMPAN</button>
                                            <button @click="emptyData()" type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                        </div>
                                    </form>
                            </div>
                        </div>
                    </div>
                  <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->


                  <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                    <div class="modal fade" id="m_edit_data" tabindex="-1" role="dialog" data-backdrop="static">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header bg-light-green">
                                    <button @click="emptyData()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span></button>
                                    <h4 class="modal-title" id="largeModalLabel">EDIT DATA</h4>
                                </div>
                            <form @submit.prevent="editData()">
                                <div class="modal-body">


                                    <div>
                                        <table style="width: 100%" class="h_isitablex">
                                            <tr>
                                                <td style="width: 10%">Periode</td>
                                                <td style="width: 1%">:</td>
                                                <td>{{rpjmd_periode}}</td>
                                            </tr>

                                            <tr>
                                                <td>Misi</td>
                                                <td>:</td>
                                                <td>[{{no_misi}}] {{misi_uraian}}</td>
                                            </tr>
                                            <tr>
                                                <td>Tujuan</td>
                                                <td>:</td>
                                                <td>[{{no_tujuan}}] {{tujuan_uraian}}</td>
                                            </tr>
                                        </table>
                                        <hr>
                                        <div class="row clearfix">
                                            <div class="col-md-2 form-control-label">
                                                <label for="kode">No Sasaran</label>
                                            </div>
                                            <div class="col-md-10">
                                                <div class="form-group">
                                                    <div class="form-line">
                                                        <input v-model="no_sasaran" type="number" min="1" class="form-control" placeholder="Nomor Sasaran">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row clearfix">
                                            <div class="col-md-2 form-control-label">
                                                <label for="kode">Uraian Sasaran</label>
                                            </div>
                                            <div class="col-md-10">
                                                <div class="form-group">
                                                    <div class="form-line">
                                                        <input v-model="uraian" type="text" class="form-control" placeholder="Ex : Meningkatnya Pelayanan Publik">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row clearfix">
                                            <div class="col-md-2 form-control-label">
                                                <label for="kode">Keterangan</label>
                                            </div>
                                            <div class="col-md-10">
                                                <div class="form-group">
                                                    <div class="form-line">
                                                        <textarea v-model="keterangan" rows="4" class="form-control no-resize" placeholder="Masukan Keterangan..."></textarea>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <div class="modal-footer">
                                    <button type="submit" class="btn btn-success waves-effect">RUBAH</button>
                                    <button @click="emptyData()" type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                </div>
                            </form>
                            </div>
                        </div>
                    </div>
                  <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->

                  <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL Indikator Sasaran Pembangunan xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                    <div class="modal" id="m_indikator_sasaran_pembangunan" tabindex="-1" role="dialog" data-backdrop="static">
                        <div class="modal-dialog modal-xlg" role="document">
                            <div class="modal-content">
                                <div class="modal-header bg-light-blue">
                                    <button @click="emptyData()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span></button>
                                    <h4 class="modal-title" id="largeModalLabel">INDIKATOR SASARAN PEMBANGUNAN</h4>
                                </div>
                            <form @submit.prevent="addData()">
                                <div class="modal-body">
                                    <div class="row paddingku">
                                        <div class="col-md-6">

                                        </div>
                                        <div class="col-md-3">

                                        </div>
                                        <div class="col-md-3 searching">
                                           <button type="button" class="btn bg-light-blue btn-sm waves-effect" title="Tambah Data" data-toggle="modal" data-target="#m_tambah_data_indikator_sasaran_pembangunan">
                                               <i class="material-icons">add</i>
                                            </button>
                                        </div>
                                    </div>
                                    <hr>
                                    <div class="table-responsive" v-if="cek_indikator">
                                        <table class="table-bordered" style="width: 100%">
                                            <thead>
                                            <tr class="bg-info kepala_table_f tabel_center">

                                                <th class="tabel_center text-center" rowspan="2" style="width: ">No Indikator</th>
                                                <th class="tabel_center text-center" rowspan="2" style="width: ">Uraian Indikator</th>
                                                <th class="tabel_center text-center" rowspan="2" style="width: ">Satuan</th>
                                                <th class="tabel_center text-center" rowspan="2" style="width: ">Rumusan Satuan</th>

                                                <th class="tabel_center text-center" style="width: " colspan="8">Target</th>

                                                <th class="tabel_center text-center" rowspan="2" style="width: 5%">#</th>
                                            </tr>
                                            <tr class="bg-info kepala_table_f tabel_center">
                                                <th class="tabel_center text-center" style="width: ">Capaian Awal</th>
                                                <th class="tabel_center text-center" style="width: ">Tahun Ke 1</th>
                                                <th class="tabel_center text-center" style="width: ">Tahun Ke 2</th>
                                                <th class="tabel_center text-center" style="width: ">Tahun Ke 3</th>
                                                <th class="tabel_center text-center" style="width: ">Tahun Ke 4</th>
                                                <th class="tabel_center text-center" style="width: ">Tahun Ke 5</th>
                                                <th class="tabel_center text-center" style="width: ">Tahun Ke 6</th>
                                                <th class="tabel_center text-center" style="width: ">Kondisi Akhir</th>
                                            </tr>
                                        </thead>
                                            <tbody>
                                            <tr class="h_isitablex" v-for="data in this.list_indikator" :key="data.indikator_id">
                                                <td class="tabel_center text-center">{{data.no_indikator}}</td>
                                                <td class="tabel_center" >{{data.uraian}}</td>
                                                <td class="tabel_center text-center">{{data.satuan}}</td>
                                                <td class="tabel_center text-center">{{data.rumus_satuan}}</td>
                                                <td class="tabel_center text-center">{{data.capaian_awal}}</td>
                                                <td class="tabel_center text-center">{{data.thn_1}}</td>
                                                <td class="tabel_center text-center">{{data.thn_2}}</td>
                                                <td class="tabel_center text-center">{{data.thn_3}}</td>
                                                <td class="tabel_center text-center">{{data.thn_4}}</td>
                                                <td class="tabel_center text-center">{{data.thn_5}}</td>
                                                <td class="tabel_center text-center">{{data.thn_6}}</td>
                                                <td class="tabel_center text-center">{{data.kondisi_akhir}}</td>

                                                <td class="tabel_center text-center" >

                                                    <!-- <button @click="removeData(data._id)" type="button" class="btn bg-red btn-xs waves-effect" title="Hapus Data" id="hapus_data"> -->
                                                        <a @click="selectIndikatorSasaran(data)" href="javascript:void(0);" style="color:orange" title="Edit Data"  data-toggle="modal" data-target="#m_edit_data_indikator_sasaran_pembangunan">
                                                            <b> <i class="material-icons" >remove_circle</i></b>
                                                        </a>
                                                        &nbsp;
                                                        <a @click="removeIndikatorSasaranData(data.indikator_id)" href="javascript:void(0);" style="color:red" title="Hapus Data">
                                                            <b> <i class="material-icons" >remove_circle</i></b>
                                                        </a>
                                                    <!-- </button> -->

                                                </td>
                                            </tr>

                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div class="modal-footer">
                                    <!-- <button type="submit" class="btn bg-indigo waves-effect">SIMPAN</button> -->
                                    <button @click="emptyData()" type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                </div>
                            </form>
                            </div>
                        </div>
                    </div>
                  <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL Indikator Sasaran Pembangunan xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->


                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL m_tambah_data_indikator_sasaran_pembangunan xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                    <div class="modal" id="m_tambah_data_indikator_sasaran_pembangunan" tabindex="-1" role="dialog" data-backdrop="static">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header bg-light-blue">
                                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span></button>
                                    <h4 class="modal-title" id="largeModalLabel">Indikator Sasaran Pembangunan</h4>
                                </div>
                            <form @submit.prevent="addDataIndikatorSasaran()">
                                <div class="modal-body">


                                <div class="row clearfix">
                                    <div class="col-md-2 form-control-label">
                                        <label for="kode">Prioritas</label>
                                    </div>
                                    <div class="col-md-10">
                                        <div class="form-group">
                                            <div class="form-line">
                                                <select class="form-control" v-model="indikator.prioritas">
                                                    <option value="prio1">Utama</option>
                                                    <option value="prio2">Bukan Utama</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row clearfix">
                                    <div class="col-md-2 form-control-label">
                                        <label for="kode">No Indikator</label>
                                    </div>
                                    <div class="col-md-10">
                                        <div class="form-group">
                                            <div class="form-line">
                                                <input v-model="indikator.no_indikator" type="text" class="form-control" placeholder="Ex : 1">
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row clearfix">
                                    <div class="col-md-2 form-control-label">
                                        <label for="kode">Uraian Indikator</label>
                                    </div>
                                    <div class="col-md-10">
                                        <div class="form-group">
                                            <div class="form-line">
                                                <input v-model="indikator.uraian" type="text" class="form-control" placeholder="Ex : ">
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row clearfix">
                                    <div class="col-md-2 form-control-label">
                                        <label for="kode">Satuan</label>
                                    </div>
                                    <div class="col-md-10">
                                        <div class="form-group">
                                            <div class="form-line">
                                                <input v-model="indikator.satuan" type="text" class="form-control" placeholder="Ex : ">
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row clearfix">
                                    <div class="col-md-2 form-control-label">
                                        <label for="kode">Rumusan Satuan</label>
                                    </div>
                                    <div class="col-md-10">
                                        <div class="form-group">
                                            <div class="form-line">
                                                <input v-model="indikator.rumus_satuan" type="text" class="form-control" placeholder="Ex : ">
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row clearfix">
                                    <div class="col-md-2 form-control-label">
                                        <label for="kode">Capaian Awal</label>
                                    </div>
                                    <div class="col-md-10">
                                        <div class="form-group">
                                            <div class="form-line">
                                                <input v-model="indikator.capaian_awal" type="text" class="form-control" placeholder="Ex : ">
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row clearfix">
                                    <div class="col-md-2 form-control-label">
                                        <label for="kode">Target Tahun 1</label>
                                    </div>
                                    <div class="col-md-2">
                                        <div class="form-group">
                                            <div class="form-line">
                                                <input v-model="indikator.thn_1" type="text" class="form-control" placeholder="Ex : ">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-2 form-control-label">
                                        <label for="kode">Target Tahun 2</label>
                                    </div>
                                    <div class="col-md-2">
                                        <div class="form-group">
                                            <div class="form-line">
                                                <input v-model="indikator.thn_2" type="text" class="form-control" placeholder="Ex : ">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-2 form-control-label">
                                        <label for="kode">Target Tahun 3</label>
                                    </div>
                                    <div class="col-md-2">
                                        <div class="form-group">
                                            <div class="form-line">
                                                <input v-model="indikator.thn_3" type="text" class="form-control" placeholder="Ex : ">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row clearfix">
                                    <div class="col-md-2 form-control-label">
                                        <label for="kode">Target Tahun 4</label>
                                    </div>
                                    <div class="col-md-2">
                                        <div class="form-group">
                                            <div class="form-line">
                                                <input v-model="indikator.thn_4" type="text" class="form-control" placeholder="Ex : ">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-2 form-control-label">
                                        <label for="kode">Target Tahun 5</label>
                                    </div>
                                    <div class="col-md-2">
                                        <div class="form-group">
                                            <div class="form-line">
                                                <input v-model="indikator.thn_5" type="text" class="form-control" placeholder="Ex : ">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-2 form-control-label">
                                        <label for="kode">Target Tahun 6</label>
                                    </div>
                                    <div class="col-md-2">
                                        <div class="form-group">
                                            <div class="form-line">
                                                <input v-model="indikator.thn_6" type="text" class="form-control" placeholder="Ex : ">
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row clearfix">
                                    <div class="col-md-2 form-control-label">
                                        <label for="kode">Kondisi Akhir</label>
                                    </div>
                                    <div class="col-md-10">
                                        <div class="form-group">
                                            <div class="form-line">
                                                <input v-model="indikator.kondisi_akhir" type="text" class="form-control" placeholder="Ex : ">
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                </div>
                                <div class="modal-footer">
                                    <button type="submit" class="btn bg-light-blue waves-effect" >SIMPAN</button>
                                    <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                </div>
                            </form>
                            </div>
                        </div>
                    </div>
                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL m_tambah_data_indikator_sasaran_pembangunan xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->

                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL m_edit_data_indikator_sasaran_pembangunan xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                    <div class="modal" id="m_edit_data_indikator_sasaran_pembangunan" tabindex="-1" role="dialog" data-backdrop="static">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header bg-orange">
                                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span></button>
                                    <h4 class="modal-title" id="largeModalLabel">Edit Indikator Sasaran Pembangunan</h4>
                                </div>
                            <form @submit.prevent="updateDataIndikatorSasaran()">
                                <div class="modal-body">


                                <div class="row clearfix">
                                    <div class="col-md-2 form-control-label">
                                        <label for="kode">Prioritas</label>
                                    </div>
                                    <div class="col-md-10">
                                        <div class="form-group">
                                            <div class="form-line">
                                                <select class="form-control" v-model="indikator.prioritas">
                                                    <option value="prio1">Utama</option>
                                                    <option value="prio2">Bukan Utama</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row clearfix">
                                    <div class="col-md-2 form-control-label">
                                        <label for="kode">No Indikator</label>
                                    </div>
                                    <div class="col-md-10">
                                        <div class="form-group">
                                            <div class="form-line">
                                                <input v-model="indikator.no_indikator" type="text" class="form-control" placeholder="Ex : 1">
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row clearfix">
                                    <div class="col-md-2 form-control-label">
                                        <label for="kode">Uraian Indikator</label>
                                    </div>
                                    <div class="col-md-10">
                                        <div class="form-group">
                                            <div class="form-line">
                                                <input v-model="indikator.uraian" type="text" class="form-control" placeholder="Ex : ">
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row clearfix">
                                    <div class="col-md-2 form-control-label">
                                        <label for="kode">Satuan</label>
                                    </div>
                                    <div class="col-md-10">
                                        <div class="form-group">
                                            <div class="form-line">
                                                <input v-model="indikator.satuan" type="text" class="form-control" placeholder="Ex : ">
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row clearfix">
                                    <div class="col-md-2 form-control-label">
                                        <label for="kode">Rumusan Satuan</label>
                                    </div>
                                    <div class="col-md-10">
                                        <div class="form-group">
                                            <div class="form-line">
                                                <input v-model="indikator.rumus_satuan" type="text" class="form-control" placeholder="Ex : ">
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row clearfix">
                                    <div class="col-md-2 form-control-label">
                                        <label for="kode">Capaian Awal</label>
                                    </div>
                                    <div class="col-md-10">
                                        <div class="form-group">
                                            <div class="form-line">
                                                <input v-model="indikator.capaian_awal" type="text" class="form-control" placeholder="Ex : ">
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row clearfix">
                                    <div class="col-md-2 form-control-label">
                                        <label for="kode">Target Tahun 1</label>
                                    </div>
                                    <div class="col-md-2">
                                        <div class="form-group">
                                            <div class="form-line">
                                                <input v-model="indikator.thn_1" type="text" class="form-control" placeholder="Ex : ">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-2 form-control-label">
                                        <label for="kode">Target Tahun 2</label>
                                    </div>
                                    <div class="col-md-2">
                                        <div class="form-group">
                                            <div class="form-line">
                                                <input v-model="indikator.thn_2" type="text" class="form-control" placeholder="Ex : ">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-2 form-control-label">
                                        <label for="kode">Target Tahun 3</label>
                                    </div>
                                    <div class="col-md-2">
                                        <div class="form-group">
                                            <div class="form-line">
                                                <input v-model="indikator.thn_3" type="text" class="form-control" placeholder="Ex : ">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row clearfix">
                                    <div class="col-md-2 form-control-label">
                                        <label for="kode">Target Tahun 4</label>
                                    </div>
                                    <div class="col-md-2">
                                        <div class="form-group">
                                            <div class="form-line">
                                                <input v-model="indikator.thn_4" type="text" class="form-control" placeholder="Ex : ">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-2 form-control-label">
                                        <label for="kode">Target Tahun 5</label>
                                    </div>
                                    <div class="col-md-2">
                                        <div class="form-group">
                                            <div class="form-line">
                                                <input v-model="indikator.thn_5" type="text" class="form-control" placeholder="Ex : ">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-2 form-control-label">
                                        <label for="kode">Target Tahun 6</label>
                                    </div>
                                    <div class="col-md-2">
                                        <div class="form-group">
                                            <div class="form-line">
                                                <input v-model="indikator.thn_6" type="text" class="form-control" placeholder="Ex : ">
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row clearfix">
                                    <div class="col-md-2 form-control-label">
                                        <label for="kode">Kondisi Akhir</label>
                                    </div>
                                    <div class="col-md-10">
                                        <div class="form-group">
                                            <div class="form-line">
                                                <input v-model="indikator.kondisi_akhir" type="text" class="form-control" placeholder="Ex : ">
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                </div>
                                <div class="modal-footer">
                                    <button type="submit" class="btn bg-light-blue waves-effect" >SIMPAN</button>
                                    <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                </div>
                            </form>
                            </div>
                        </div>
                    </div>
                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL m_edit_data_indikator_sasaran_pembangunan xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->


                <!-- ============================================================ MODAL ======================================================================== -->

        <!-- ============================================================ MULAI ======================================================================== -->
            </div>

        </div>

        </div>
      </section>

    </div>
</template>


<script>

    const ADD_URL_MISI = URL_APP+'api/v1/planning_misi/';
    const ADD_URL_RPJMD = URL_APP+'api/v1/planning_rpjmd/';
    const ADD_URL_TUJUAN = URL_APP+'api/v1/planning_tujuan/';
    const ADD_URL = URL_APP+'api/v1/planning_sasaran_pembangunan/';


    export default {
        name: "planning_urusan",
        data() {
            return {

                sasaran_id : '',

                filter_rpjmd: '',
                filter_misi: '',
                filter_tujuan: '',

                no_sasaran : 0,
                uraian : '',
                keterangan : '',

                rpjmd_periode : '',
                no_misi : '',
                misi_uraian : '',
                tujuan_id : '',
                no_tujuan : '',
                tujuan_uraian : '',


                list_sasaran: [],
                list_tujuan: [],
                list_rpjmd: [],
                list_misi: [],

                cek_tujuan : false,
                cek_indikator : false,

                indikator : {
                    indikator_id : '',
                    sasaran_id : '',
                    no_indikator : 0,
                    prioritas : 'prio1',
                    uraian : '',
                    satuan : '',
                    rumus_satuan : '',
                    capaian_awal : 0,
                    thn_1 : 0,
                    thn_2 : 0,
                    thn_3 : 0,
                    thn_4 : 0,
                    thn_5 : 0,
                    thn_6 : 0,
                    kondisi_akhir : 0,
                },

                list_indikator: [],



                page_first : 1,
                page_last : 0,
                cari_value : '',
                cek_load_data : true,
            }
        },

        mounted() {
            this.getData();
            this.getPeriode();
            localStorage.sidemenu = 'planing';
        },

        // =============================================================== METHODS =========================================================================
        methods : {
            getPeriode: function(){
                fetch(ADD_URL_RPJMD, {
                    method : 'GET',
                    headers : {
                        'content-type' : 'application/json',
                        authorization : "kikensbatara " + localStorage.token
                    },

                }).then(res => res.json()).then((res_data)=>{
                    //   console.log(res_data);
                    this.list_rpjmd = res_data
                })


            },

            getMisi: function(){
                if (this.filter_rpjmd == '') {
                    this.filter_misi = '';
                    this.filter_tujuan = '';
                }
                fetch(ADD_URL_MISI+'misi_id_rpjmd', {
                    method : 'POST',
                    headers : {
                        'content-type' : 'application/json',
                        authorization : "kikensbatara " + localStorage.token
                    },
                    body : JSON.stringify({
                        rpjmd_id : this.filter_rpjmd
                    })

                }).then(res => res.json()).then((res_data)=>{
                        // console.log(res_data);
                        this.list_misi = res_data
                        this.getData();

                        
                })
            },

            getTujuan: function(){
                if (this.filter_misi == '') {
                    this.filter_tujuan = '';
                }
                fetch(ADD_URL_TUJUAN+'tujuan_id_misi', {
                    method : 'POST',
                    headers : {
                        'content-type' : 'application/json',
                        authorization : "kikensbatara " + localStorage.token
                    },
                    body : JSON.stringify({
                        misi_id : this.filter_misi
                    })

                }).then(res => res.json()).then((res_data)=>{
                        console.log(res_data);
                        this.list_tujuan = res_data
                        this.getData();
                })

            },


            addData: function(){
                fetch(ADD_URL+'createData', {
                    method: 'POST',
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara "+ localStorage.token
                    },
                    body: JSON.stringify({
                        tujuan_id : this.filter_tujuan,
                        no_sasaran : this.no_sasaran,
                        uraian : this.uraian,
                        keterangan : this.keterangan,

                    })
                }).then(res => res.json()).then((data_sasaran) => {
                    this.alertku('success', 'Berhasil Menambah Data!');
                    this.getData();
                });
            },
            getData: function(){
                this.cek_load_data = true;
                fetch(ADD_URL+'readData', {
                    method : 'POST',
                    headers : {
                    "content-type": "application/json",
                    authorization: "kikensbatara " + localStorage.token
                    },
                    body : JSON.stringify({
                        data_ke : this.page_first,
                        cari_value : this.cari_value,
                        rpjmd_id : this.filter_rpjmd,
                        misi_id : this.filter_misi,
                        tujuan_id : this.filter_tujuan,
                    })
                }).then((res) => res.json()).then((data_sasaran) => {
                    // console.log(data_sasaran);
                    this.list_sasaran = data_sasaran.data;
                    this.page_last = data_sasaran.jml_data;
                    this.cek_load_data = false;
                })
            },
            editData: function(){
                fetch(ADD_URL+'update', {
                    method: 'POST',
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara " + localStorage.token
                    },
                    body: JSON.stringify({
                        tujuan_id : this.tujuan_id,
                        no_sasaran : this.no_sasaran,
                        uraian : this.uraian,
                        keterangan : this.keterangan,
                        sasaran_id : this.sasaran_id
                    })
                }).then((res_data) => {
                    this.alertku("success", "Berhasil Mengubah Data!");
                    this.getData();
                });
            },


            selectData : function(data){
                this.no_sasaran = data.no_sasaran;
                this.sasaran_id = data.sasaran_id;
                this.uraian = data.uraian;
                this.keterangan = data.keterangan;
                this.rpjmd_periode = data.rpjmd_periode;
                this.no_misi = data.no_misi;
                this.misi_uraian = data.misi_uraian;
                this.tujuan_id = data.tujuan_id;
                this.no_tujuan = data.no_tujuan;
                this.tujuan_uraian = data.tujuan_uraian;

                this.indikator.sasaran_id = data.sasaran_id;

            },
            removeData : function(id){
                this.$swal({
                title: 'Apa Anda Ingin Menghapus Data?',
                text: 'Data Yang Telah Dihapus Tidak Dapat Dikembalikan',
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Ya',
                cancelButtonText: 'Batal',
                showCloseButton: true,
                showLoaderOnConfirm: true
                }).then((result) => {
                if(result.value) {
                    fetch(ADD_URL+"delete", {
                        method : 'POST',
                        headers : {
                        'content-type' : 'application/json',
                        authorization : "kikensbatara "+ localStorage.token,
                        },
                        body : JSON.stringify({
                            sasaran_id : id,
                        })
                    }).then(()=>{
                        this.alertku("success", "Sukses Menghapus Data!");
                        this.getData();
                    });
                    this.$swal('Terhapus', 'Berhasil Menghapus Data!', 'success')
                } else {
                    this.$swal('Batal', 'Batal Menghapus Data!', 'info')
                }
                })
            },
            removeIndikatorSasaranData : function(id){
                this.$swal({
                title: 'Apa Anda Ingin Menghapus Data?',
                text: 'Data Yang Telah Dihapus Tidak Dapat Dikembalikan',
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Ya',
                cancelButtonText: 'Batal',
                showCloseButton: true,
                showLoaderOnConfirm: true
                }).then((result) => {
                if(result.value) {
                    fetch(ADD_URL+'deleteDataIndikator', {
                    method: 'POST',
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara "+ localStorage.token
                    },
                    body: JSON.stringify({indikator_id : id})
                    }).then(res => res.json()).then((data_sasaran) => {
                        this.alertku('success', 'Berhasil Menambah Data!');
                        this.getDataIndikatorSasaran();
                    });

                    this.$swal('Terhapus', 'Berhasil Menghapus Data!', 'success')
                } else {
                    this.$swal('Batal', 'Batal Menghapus Data!', 'info')
                }
                })
            },
            selectDataIndikatorSasaranData: function(data){
                this.cek_indikator = true;
                this.selectData(data);
                this.getDataIndikatorSasaran();
            },
            selectIndikatorSasaran : function(data){
                this.indikator = {
                    indikator_id : data.indikator_id,
                    sasaran_id : data.sasaran_id,
                    no_indikator : data.no_indikator,
                    prioritas : data.prioritas,
                    uraian : data.uraian,
                    satuan : data.satuan,
                    rumus_satuan : data.rumus_satuan,
                    capaian_awal : data.capaian_awal,
                    thn_1 : data.thn_1,
                    thn_2 : data.thn_2,
                    thn_3 : data.thn_3,
                    thn_4 : data.thn_4,
                    thn_5 : data.thn_5,
                    thn_6 : data.thn_6,
                    kondisi_akhir : data.kondisi_akhir,
                };
            },

            getDataIndikatorSasaran : function(){
                fetch(ADD_URL+'readDataIndikator', {
                    method : 'POST',
                    headers : {
                    "content-type": "application/json",
                    authorization: "kikensbatara " + localStorage.token
                    },
                    body : JSON.stringify({
                        sasaran_id : this.sasaran_id,
                    })
                }).then((res) => res.json()).then((res_data) => {
                    // console.log(res_data);
                    this.list_indikator = res_data;

                })
            },
            addDataIndikatorSasaran: function(){
                fetch(ADD_URL+'createDataIndikator', {
                    method: 'POST',
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara "+ localStorage.token
                    },
                    body: JSON.stringify(this.indikator)
                }).then(res => res.json()).then((data_sasaran) => {
                    this.alertku('success', 'Berhasil Menambah Data!');
                    this.getDataIndikatorSasaran();
                });
                
            },
            updateDataIndikatorSasaran: function(){
                fetch(ADD_URL+'updateDataIndikator', {
                    method: 'POST',
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara "+ localStorage.token
                    },
                    body: JSON.stringify(this.indikator)
                }).then(res => res.json()).then((data_sasaran) => {
                    this.alertku('success', 'Berhasil Mengubah Data!');
                    this.getDataIndikatorSasaran();
                });
                
            },

            emptyData : function(){
                this.cek_tujuan = false;
                this.no_sasaran = '';
                this.sasaran_id = '';
                this.uraian = '';
                this.keterangan = '';
                this.rpjmd_periode = '';
                this.no_misi = '';
                this.misi_uraian = '';
                this.no_tujuan = '';
                this.tujuan_uraian = '';
                this.cek_indikator = false;

                this.list_indikator = [];
            },

            cek_tujuan_add : function(){
                if (this.filter_tujuan == '') {
                    this.cek_tujuan = false;
                }else{
                    this.cek_tujuan = true;
                }
            },

            //PAGINASI
                alertku : function(type, title){
                this.$swal({
                    type: type,
                    title: title,
                    showConfirmButton: false,
                    timer: 800
                });
                },

                btn_prev : function(){
                    this.cek_load_data = true;
                    if(this.page_first>1){
                        this.page_first--
                    }else{
                        this.page_first = 1;
                    }
                    this.getData();
                },

                btn_next : function(){
                    this.cek_load_data = true;
                    if(this.page_first >= this.page_last){
                        this.page_first == this.page_last
                    }else{
                        this.page_first++;
                    }
                    this.getData();
                },

                cari_data : function(){
                    this.cek_load_data = true;
                    this.page_first = 1;
                    this.getData();
                }

            //PAGINASI
        },
        // =============================================================== METHODS =========================================================================

    };
</script>
